// 탭 전환처럼 전체 페이지 이동이 곧 일어날 것임을 다른 컴포넌트에 알리는
// 아주 단순한 전역 플래그. window.location.href를 대입하는 시점과 실제
// 브라우저가 페이지를 갈아치우는 시점 사이에는 짧은 시차가 있어서, 그 사이에
// 이전 페이지의 비동기 응답이 도착해 URL을 다시 바꿔버릴 수 있다 — 이동을
// 시작하는 쪽(Header)에서 동기적으로 이 값을 세워두면, 각 페이지는 지연
// 도착한 응답이 URL을 건드리기 전에 이를 확인해 무시할 수 있다.
let isNavigatingAway = false;

export const markNavigatingAway = () => {
  isNavigatingAway = true;
};

export const isPageNavigatingAway = () => isNavigatingAway;
